import { useState, Suspense } from "react";
import { Flex, Box, Center, Spinner } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function MainLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const userName = sessionStorage.getItem("user_name") || "User";

  return (
    <Flex direction="column" h="100vh" overflow="hidden">
      <Header userName={userName} />
      <Flex flex="1" overflow="hidden" position="relative">
        {isSidebarOpen && (
          <Sidebar
            isOpen={isSidebarOpen}
            onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
          />
        )}
        <Box flex="1" overflowY="auto" bg="gray.50">
          <Suspense
            fallback={
              <Center h="100%" py="20">
                <Spinner size="lg" />
              </Center>
            }
          >
            <Outlet />
          </Suspense>
        </Box>
        {!isSidebarOpen && (
          <Box position="absolute" left="0" top="8px" zIndex={20}>
            <Sidebar
              isOpen={isSidebarOpen}
              onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
              showToggleOnly={true}
            />
          </Box>
        )}
      </Flex>
    </Flex>
  );
}
